<script setup>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { api } from '../services/api'
import { store } from '../store'

const router = useRouter()
const route = useRoute()
const email = ref('')
const password = ref('')
const showPassword = ref(false)
const loading = ref(false)
const error = ref('')
// Server yêu cầu captcha sau 3 lần đăng nhập sai; mỗi mã chỉ dùng được một lần.
const captcha = ref(null)
const captchaAnswer = ref('')

async function loadCaptcha() {
  captchaAnswer.value = ''
  try { captcha.value = await api('/auth/captcha') }
  catch (err) { error.value = err.message }
}

async function submit() {
  loading.value = true
  error.value = ''
  const extra = captcha.value ? { captcha_id: captcha.value.captcha_id, captcha_answer: captchaAnswer.value } : {}
  try {
    const user = await store.login(email.value, password.value, extra)
    const fallback = user.role === 'parent' ? '/phu-huynh' : user.role === 'admin' ? '/quan-tri' : '/'
    router.push(route.query.next || fallback)
  } catch (err) {
    error.value = err.message
    if (err.data?.captcha_required) await loadCaptcha()
    else captcha.value = null
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div class="login-page">
    <section class="login-visual">
      <div class="login-brand"><span class="brand-mark">✳</span> VuiHoc<span class="brand-dot">.</span></div>
      <div class="login-copy">
        <p class="eyebrow">Nền tảng học tập thông minh</p>
        <h1>Học chắc kiến thức.<br><em>Tiến bộ mỗi ngày.</em></h1>
        <p>Bài học được tổ chức theo từng chủ đề, có luyện tập và lời giải rõ ràng để mỗi học sinh tự tin chinh phục chương trình của lớp mình.</p>
        <div class="visual-cards">
          <div class="visual-card"><i>∑</i><div><strong>Toán</strong><small>Tư duy & giải quyết vấn đề</small></div></div>
          <div class="visual-card"><i>Aa</i><div><strong>Ngữ văn</strong><small>Đọc · Viết · Nói & nghe</small></div></div>
          <div class="visual-card"><i>En</i><div><strong>Tiếng Anh</strong><small>Nghe · Nói · Đọc · Viết</small></div></div>
        </div>
      </div>
      <div class="login-footnote">Bám sát Chương trình Giáo dục phổ thông 2018 · Năm học 2026–2027</div>
    </section>

    <section class="login-panel">
      <form class="login-box" @submit.prevent="submit">
        <p class="eyebrow">Chào mừng trở lại</p>
        <h2>Đăng nhập để học tiếp</h2>
        <p>Mỗi bài học hôm nay là một bước tiến mới của em.</p>
        <div v-if="error" class="form-error">{{ error }}</div>
        <div class="form-group">
          <label for="email">Email</label>
          <div class="field-wrap"><span class="field-icon">＠</span><input id="email" v-model="email" class="form-control" type="email" placeholder="Nhập email của bạn" autocomplete="email" required></div>
        </div>
        <div class="form-group">
          <label for="password">Mật khẩu</label>
          <div class="field-wrap">
            <span class="field-icon">◇</span>
            <input id="password" v-model="password" class="form-control" :type="showPassword ? 'text' : 'password'" placeholder="Nhập mật khẩu" autocomplete="current-password" required>
            <button class="password-toggle" type="button" aria-label="Hiện mật khẩu" @click="showPassword = !showPassword">{{ showPassword ? 'Ẩn' : 'Hiện' }}</button>
          </div>
        </div>
        <div v-if="captcha" class="form-group">
          <label for="captcha">Mã xác nhận</label>
          <div class="captcha-row">
            <img :src="captcha.image" alt="Hình mã xác nhận gồm 5 chữ số" width="190" height="64">
            <button class="btn btn-light" type="button" :disabled="loading" @click="loadCaptcha">Đổi mã khác</button>
          </div>
          <input id="captcha" v-model="captchaAnswer" class="form-control" inputmode="numeric" autocomplete="off" maxlength="10" placeholder="Nhập 5 chữ số trong hình" required>
        </div>
        <button class="btn btn-primary login-submit" :disabled="loading">{{ loading ? 'Đang đăng nhập…' : 'Vào lớp học  →' }}</button>
      </form>
    </section>
  </div>
</template>
